import { PROCESS } from "@/lib/content";
import { SectionHeading } from "./Primitives";

export const Process = () => (
  <section className="bg-white py-16 sm:py-28 scroll-mt-20 rule" id="how-it-works" data-testid="process-section">
    <div className="container-x">
      <SectionHeading eyebrow="How the assessment works" title="From your first question to your results." lead="One visit, one week of monitoring, one conversation." testId="process-heading" />
      <ol className="mt-12 grid gap-10 md:grid-cols-3 md:gap-8 list-none m-0 p-0" data-testid="process-steps">
        {PROCESS.map((s) => (
          <li key={s.n} className="border-t border-divider pt-6" data-testid={`process-step-${s.n}`}>
            <span className="mono text-sec">Step {s.n}</span>
            <h3 className="h-sub mt-3">{s.title}</h3>
            <p className="mt-3 text-base leading-relaxed text-ink">{s.text}</p>
          </li>
        ))}
      </ol>
    </div>
  </section>
);
